import { ITabela } from "./TabelaInterface";
import React, { useState } from "react";
import { Button } from "../Buttons/Button";
import { mdiEye, mdiFileEditOutline, mdiFilePdfBox, mdiPrinter, mdiTrashCanOutline, mdiDownload } from "@mdi/js";
import Avatar from "@mui/material/Avatar";
import Paginacao from "../Pagination";
import { Badge } from "react-bootstrap";

interface TabelaProps {
  coluna: ITabela[];
  dados: any[];
  itemsPerPage: number;
  usaVisu?: boolean;
  usaEdit?: boolean;
  usaDelete?: boolean;
  usaImprimir?: boolean;
  usaDownload?: boolean;
  onVisuClick: (dados: any) => void;
  onEditClick: (dados: any) => void;
  onDeleteClick: (dados: any) => void;
  onImprimirClick: (dados: any) => void;
  onDownloadClick?: (arquivo: any) => void;
  id?: string;
  descEditar?: string;
  descExcluir?: string;
  descVisualizar?: string;
  descImprimir?: string;
  descDownload?: string;
  iconeEditar?: string;
  iconeExcluir?: string;
  iconeVisualizar?: string;
  iconeImprimir?: string;
  iconeDownload?: string;
}
const Tabela: React.FC<TabelaProps> = ({
  coluna,
  dados,
  itemsPerPage,
  usaVisu = true,
  usaEdit = true,
  usaDelete = true,
  usaImprimir = true,
  usaDownload = false,
  onVisuClick,
  onDeleteClick,
  onEditClick,
  onImprimirClick,
  onDownloadClick,
  id,
  descEditar,
  descExcluir,
  descVisualizar,
  descImprimir,
  descDownload,
  iconeEditar,
  iconeExcluir,
  iconeVisualizar,
  iconeImprimir,
  iconeDownload,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(dados.length / itemsPerPage);
  const itens = dados.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // const itens = Array.isArray(dados)
  //   ? dados.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
  //   : [];

  return (
    <div className="table-responsive">
      <table className="table table-centered w-100 dt-responsive nowrap table-striped table-hover">
        <thead className="table-cabecalho">
          <tr>
            {coluna.map((item, index) => (
              <th key={index}>{item.titulo}</th>
            ))}
            <th style={{ textAlign: 'right' }} className="px-2">Ações</th>
          </tr>
        </thead>
        <tbody>
          {itens.map((item, index) => (
            <tr key={index}>
              {coluna.map((coluna, index) => (
                <td key={index}>
                  {coluna.acesso === "avatar" ? (
                    item[coluna.acesso] !== "" ? (
                      <Avatar
                        src={`data:image/png;base64,${item[coluna.acesso]}`}
                        alt="Avatar"
                      />
                    ) : (
                      <Avatar src={""} alt="Avatar" />
                    )
                  ) : coluna.acesso === "situacao" ? (
                    item[coluna.acesso] === 1 ? (
                      <Badge bg="primary">Ativo</Badge>
                    ) : (
                      <Badge bg="danger">Inativo</Badge>
                    )
                    ) : coluna.acesso === "status" ? (
                      item[coluna.acesso] === 1 ? (
                        <Badge bg="primary">Ativo</Badge>
                      ) : (
                        <Badge bg="danger">Inativo</Badge>
                      )
                    ) : coluna.acesso === "enviou_email" ? (
                      item[coluna.acesso] === 1 ? (
                        <Badge bg="success">Sim</Badge>
                      ) : (
                        <Badge bg="danger">Não</Badge>
                      )
                    ) : coluna.acesso === "enviou_whatsapp" ? (
                      item[coluna.acesso] === 1 ? (
                        <Badge bg="success">Sim</Badge>
                      ) : (
                        <Badge bg="danger">Não</Badge>
                      )
                    ): coluna.acesso === "status_pre_cad" ? (
                      item[coluna.acesso] === 0 ? (
                        <Badge bg="primary">Novo</Badge>
                      ) : (
                        <Badge bg="warning">Em Digitação</Badge>
                      )
                    ) : coluna.render ? (
                      coluna.render(item)
                    ) : (
                    item[coluna.acesso]
                  )}
                </td>
              ))}
              <td style={{ textAlign: 'right' }} className="px-2">
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '3px' }}>
                  {usaVisu && (
                    <Button
                      onclick={() => onVisuClick(item)}
                      icone={iconeVisualizar || mdiEye}
                      type="button"
                      className="botaoTransparente"
                      title={descVisualizar || "Visualizar"}
                    />
                  )}
                  {usaEdit && (
                    <Button
                      onclick={() => onEditClick(item)}
                      icone={iconeEditar || mdiFileEditOutline}
                      type="button"
                      className="botaoTransparente"
                      title={descEditar || "Editar"}
                    />
                  )}
                  {usaDelete && (
                    <Button
                      onclick={() => onDeleteClick(item)}
                      icone={iconeExcluir || mdiTrashCanOutline}
                      type="button"
                      className="botaoTransparente"
                      title={descExcluir || "Excluir"}
                    />
                  )}
                  {usaImprimir && (
                    <Button
                      onclick={() => onImprimirClick(item)}
                      icone={iconeImprimir || mdiPrinter}
                      type="button"
                      className="botaoTransparente"
                      title={descImprimir || "Imprimir"}
                    />
                  )}
                  {usaDownload && item.arquivos && item.arquivos.length > 0 && (
                    <>
                      {item.arquivos.map((arquivo: any, idx: number) => (
                        <Button
                          key={idx}
                          onclick={() => onDownloadClick && onDownloadClick(arquivo)}
                          icone={iconeDownload || mdiDownload}
                          type="button"
                          className="botaoTransparente"
                          title={`${descDownload || "Download"}: ${arquivo.nome}`}
                        />
                      ))}
                    </>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Paginacao
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        dados={dados}
      />
    </div>
  );
};
export default Tabela;
